import utils from "../../../services/utils";
import trackEvent from "@/services/tracking";
import { mapGetters } from "vuex";

export default {
    props: [
        "data", "quickShop", "filterOrSortUsed",
        "listOfFilterTypes", "parentCategory", "category",
        "queryId", "searchIndex", "pdpPage", "fitHeight"
    ],

  data() {
    return {
      showBrandName: true,
      trackingInfo: {
        "Product name": this.data.name,
        "Brand name": this.data.brand.company_name,
      },
    };
  },

  methods: {
    openQuickShopModal: openQuickShopModal,
    urlFormatter: utils.urlSafeString,
    handlePDPClick,
    handleQuickShopButtonClick,
    showUnregisteredModal,
    handleTileClick,
    getRouterLink,
  },

  beforeMount() {
    this.showBrandName = this.$route.name !== "brand-bio";
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
};

function handleQuickShopButtonClick() {
  if (!this.user) {
    this.showUnregisteredModal();
    return;
  }

  this.handlePDPClick();
  this.openQuickShopModal(this.data);
}

function handlePDPClick() {
  this.$ma.trackEvent({
    action: "Pdp Click",
    properties: {
      "Filter or Sort Used": this.filterOrSortUsed,
      "Filter Type(s)": this.listOfFilterTypes,
    },
  });
}

function openQuickShopModal(product) {
  this.$eventBus.$emit("show-quick-shop-modal", product);
}

function showUnregisteredModal() {
  this.$eventBus.$emit("apply-modal-unregistered", this.data);
}

function handleTileClick() {
    if(this.searchIndex && this.queryId) {
        trackEvent("PLP;Product Clicked", {
            objectID : this.data.objectID,
            queryID: this.queryId,
            index:this.searchIndex
        });
        this.$trackingStore.commit('setIndexName',this.searchIndex)
        this.$trackingStore.commit('setQueryId',this.queryId)
        this.$trackingStore.commit('setSource','search')
    }
    this.handlePDPClick();
    if (!this.user) {
        this.showUnregisteredModal();
    }
}

function getRouterLink() {
  return {
    name: "productDetails",
    params: {
      productName: this.urlFormatter(this.data.name),
      productId: this.data.id,
    },
    query: {
      parentCategory: this.parentCategory,
      category: this.category,
    },
  };
}
